import RapipagoArchivoPage from "./RapipagoArchivoPage";

export {RapipagoArchivoPage}
export default RapipagoArchivoPage
